import { render, staticRenderFns } from "./BTabPane.vue?vue&type=template&id=7cbf37a1&"
import script from "./BTabPane.vue?vue&type=script&lang=ts&"
export * from "./BTabPane.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports